import { ReactElement, useMemo } from "react";
import { CommunityListItem } from "../../../Items/CommunityListItem";
import { GlobalSearchResultItemKind } from "client/Api/TitleBar/GlobalSearch/globalSearch";
import { GlobalSearchItem } from "../../../GlobalSearchItem/GlobalSearchItem";
import { generateTrackingId } from "client/Misc/utils";
import { useCommunityNavigationHandler } from "../../../Navigation/useCommunityNavigationHandler";
import { ValidGlobalSearchItemPersistedModel } from "client/Features/Search/RecentSearch/Persistence/validation";
import { AppColorKind, AppColorViewModel } from "client/Api/Apps/common";
import { convertAppColor } from "client/Features/Search/RecentSearch/Persistence/convertPersistedData";

export type CommunityItemViewProps = {
	item: ValidGlobalSearchItemPersistedModel<GlobalSearchResultItemKind.Community>;
	itemIndex: number;
	onRemove: () => void;
	tabIndex: number;
};

export const CommunityItemView = (props: CommunityItemViewProps): ReactElement => {
	const {
		item,
		itemIndex,
		onRemove,
		tabIndex
	} = props;

	const {
		id,
		isCurrentUserMember,
		memberCount,
		name,
		color: persistedColor
	} = item.community;

	const color = useMemo(
		(): AppColorViewModel => persistedColor
			? convertAppColor(persistedColor)
			: { kind: AppColorKind.Primary },
		[persistedColor]
	);

	const openHandler: () => void = useCommunityNavigationHandler({
		id,
		recentlyOpenedItem: item
	});

	return (
		<GlobalSearchItem
			trackingId={generateTrackingId("community-item", `|${id}`)}
			onClick={openHandler}
		>
			<CommunityListItem
				id={id}
				isCurrentUserMember={isCurrentUserMember}
				memberCount={memberCount}
				name={name}
				color={color}
				onRemove={onRemove}
				itemIndex={itemIndex}
				tabIndex={tabIndex}
				onExecute={openHandler}
			/>
		</GlobalSearchItem>
	);
};
CommunityItemView.displayName = "CommunityItemView";